import { ActiveConfiguration } from '@icc/shared/types';
import { IConfiguratorsDataService } from '@icc/shared/types';
import { ExternalBlindConfiguration } from './external-blind-configuration';
import { RollerShutterActiveConfiguration } from './roller-shutter-active-configuration';

export class ExternalBlindActiveConfiguration extends RollerShutterActiveConfiguration implements ActiveConfiguration{
    public static is(configuration): configuration is ExternalBlindActiveConfiguration {
        return configuration instanceof ExternalBlindActiveConfiguration || !configuration.$version;
    }
    type: 'external_blind' = 'external_blind';


    constructor(configuration?, configuratorsDataService?: IConfiguratorsDataService) {
        super(configuration, configuratorsDataService);
        if (configuration) {
            if (ExternalBlindActiveConfiguration.is(configuration)) {
                for (const propName in configuration) {
                    if (this.hasOwnProperty(propName)) {
                        this[propName] = configuration[propName];
                    }
                }
            } else {
                if (ExternalBlindConfiguration.is(configuration) && configuratorsDataService) {
                    this.RollerShutter.mountingLength = configuration.rollerShutter.mountingLength;
                    this.RollerShutter.crankSlope = configuration.rollerShutter.crankSlope;
                    this.RollerShutter.crankLength = configuration.rollerShutter.crankLength;
                    this.RollerShutter.crankOffset = configuration.rollerShutter.crankOffset;
                }
            }
        }
    }
}
